<template>
    <div class="login">
        <vue-headful
            title="TZ Design Box - Login"
            description="TZ Design Box"
        />
        <section class="section login">
            <LoginBox/>
        </section>
    </div>
</template>

<script>
import LoginBox from '~/LoginBox';
import { mapGetters } from 'vuex';

export default {
    name: 'Login',
    props: ["location"],
    computed: {
        ...mapGetters(['getUserLoading'])
    },
    components:{LoginBox},
    mounted () {
        const ua   = window.navigator.userAgent
        const msie = ua.indexOf("MSIE ");
        console.log (msie, navigator.userAgent)
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            this.$router.push ({ name : "use-other-broser"})
        }
    }
}
</script>
